import React, { useMemo } from 'react';
import PaymentApi from '../PaymentApi';
import PaymentSettings from '../PaymentSettings';
import DropMenu from '@dex/bubl-dash/src/lib/components/DropMenu/DropMenu';
import Link from '@dex/bubl-dash/src/lib/components/Link/Link';

const PaymentActions: React.FC<any> = (props: any) => {

    const { data } = props;

    const del = PaymentApi.delete(data.id, {
        onComplete: (response) => {

            if (data.modelName && data.id) {
                const event = new CustomEvent(data.modelName + data.id, { detail: 'deleted' });
                window.dispatchEvent(event);
            }

        }
    });

    return useMemo(() => {

        return (

            <DropMenu>

                <Link
                    path={`${ PaymentSettings.path }/${data.id}/view`}
                >
                    View
                </Link>

                {/* <Link
                    path={`${ PaymentSettings.path }/${data.id}/edit`}
                >
                    Edit
                </Link> */}

                <Link
                    confirm={ {
                        title: `Delete ${ data[PaymentSettings.primaryKey] }`,
                        message: "Are your sure you want to perform this action?"
                    } }
                    onClick={del.run}
                >
                    Delete
                </Link>

            </DropMenu>

        )

    }, [data, del]);

}

export default PaymentActions;
